import script from "./WorkCheckBpmnInstancesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkCheckBpmnInstancesPage.vue?vue&type=script&setup=true&lang=js"

import "./WorkCheckBpmnInstancesPage.vue?vue&type=style&index=0&id=34720bfd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34720bfd"]])

export default __exports__